import { Component, OnInit } from '@angular/core';
import { TableEmpresaService } from '../shared/table-empresa.service';
import { FormBuilder, Validators } from '@angular/forms';
import { GenericResult } from 'src/app/globalClass/generic-class.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-table-empresa',
  templateUrl: './table-empresa.component.html',
  styleUrls: ['./table-empresa.component.css']
})
export class TableEmpresaComponent implements OnInit {
  
  constructor(
    private _tableEmpresaService:TableEmpresaService,
    private _fb:FormBuilder,
    private _toastr:ToastrService
  ) { }

  ngOnInit() {
  }

  formEmpresa = this._fb.group({
    idAdmEmpresa:[null,Validators.required],
    nit:[null,Validators.required],
    nombre:[null,Validators.required]
  });

  getListaEmpresa(){
    return this._tableEmpresaService.getListaEmpresa();
  }

  getListCompanyName(){
    return this._tableEmpresaService.getListCompanyName();
  }

  searchCompanyName(obj: any){
    this._tableEmpresaService.searchCompanyName(obj);
  }


  loadCompanyNit() {
    var name = this.formEmpresa.get('nombre').value;
    var company = this._tableEmpresaService.getListCompanySearch().find(i => i.nombre == name.split(' | ')[0] && i.nit == name.split(' | ')[1]);

    if (typeof company !== 'undefined' && company != null) {
      this.formEmpresa.patchValue({
          idAdmEmpresa:company.idAdmEmpresa,
          nit:company.nit,
          nombre:company.nombre
        });
    } else {
      this.formEmpresa.reset();
      this._toastr.warning('La información de la Aseguradora no es correcta.');
    }
  }

  addEmpresa(){
    let empresa = this.formEmpresa.value;
    this._tableEmpresaService.addEmpresa(empresa);
    this.formEmpresa.reset();
  }

  deleteEmpresa(idEmpresa){
    this._tableEmpresaService.deleteEmpresa(idEmpresa);
  }

  async changeNit(event){
    let nit = event.target.value;
    await this._tableEmpresaService.getCompanyForNit(nit).then((r:any)=>{
      if(r!=null){
        let empresa = r;
        this.formEmpresa.patchValue({
          idAdmEmpresa:empresa.idAdmEmpresa,
          nit:empresa.nit,
          nombre:empresa.nombre
        });
      }else{
        this._toastr.warning("No existe en el sistema una empresa o persona natural asociada a este número de documento");
        this.formEmpresa.patchValue({
          idAdmEmpresa:null,
          nombre:null
        });
      }
    });
  }
}
